let totalCustomProductPrice = 0

const setTotalYMQCustomProductPriceTo_0 = () => {
    totalCustomProductPrice = 0
}

 // update Checkout Total Cost Price
const updateCheckoutTotalCostPrice = (totalCartCost, CartCurrencyCode) => {
    try {
        // console.log(totalCartCost)
        // console.log(totalCustomProductPrice)
        // console.log(CartCurrencyCode)
        totalCartCost = (+totalCartCost) + totalCustomProductPrice,
        // console.log( totalCartCost.toFixed(2) )
        updateCheckoutButtonMinicart(`${totalCartCost.toFixed(2)} ${CartCurrencyCode}`)
        if(document.getElementsByClassName("cart__total-container").length !== 0){
            document.getElementsByClassName("cart__total-container")[0].childNodes[3].innerText = 
            "$" + `${totalCartCost.toFixed(2)} ${CartCurrencyCode}`
        }
    } catch (error) {
        console.log(error)
    }
    
}
//===============

// Two builds can share a price (Trench Elite and QB Elite), and the price map
// keeps only the last, so a Trench Elite build was added as QB Elite. Among the
// variants at this price, take the one whose title names the chosen level and
// model; with no single match, keep the price map's pick.
const buildTitleWords = (text) =>
    String(text || "").toUpperCase().replace(/ZERO2/g, " ").split(/[^A-Z]+/).filter(Boolean).sort().join(" ");

const findVariantForBuild = (price, model, level) => {
    if (!model || !Array.isArray(window.variantPriceOptions)) return undefined;
    const atPrice = window.variantPriceOptions.filter((v) => v.price === `${price}`);
    if (atPrice.length < 2) return undefined;
    const wanted = buildTitleWords(`${level || ""} ${model}`);
    const matches = atPrice.filter((v) => buildTitleWords(v.title) === wanted);
    return matches.length === 1 ? matches[0].id : undefined;
};

const findVariantID = (price, model, level) => {
    const forBuild = findVariantForBuild(price, model, level);
    if (forBuild) {
        console.log("[findVariantID] matched variant for build:", forBuild);
        return forBuild;
    }
    console.log("[findVariantID] lookup price:", price, "type:", typeof price);
    if (!window.variantPriceMap) {
        console.error("[findVariantID] window.variantPriceMap not found — ensure product template outputs it");
        return undefined;
    }
    console.log("[findVariantID] available price keys:", Object.keys(window.variantPriceMap));
    const variantID = window.variantPriceMap[`${price}`];
    if (!variantID) {
        console.error("[findVariantID] no variant matched for price:", price, "— check that a variant exists at this price");
    } else {
        console.log("[findVariantID] matched variant:", variantID);
    }
    return variantID;
};

// Outside the US the page's variant prices are that market's (CAD, or USD with a
// Managed Markets markup) while YMQ sums option prices in the shop's USD, so the
// price lookup above never matches there (Jmcasavant/certor#2315). Resolve the
// build against the same variants' US prices instead: a variant's ID is the same
// in every market, and the cart then charges that market's price for it.
let usVariantPriceOptions;
const loadUsVariantPriceOptions = async () => {
  if (usVariantPriceOptions) return usVariantPriceOptions;
  const ids = (window.variantPriceOptions || []).map((v) => v.id);
  if (!ids.length) return undefined;
  const data = await CertorgraphqlPostRequest(
    `query ($ids: [ID!]!) @inContext(country: US) { nodes(ids: $ids) { ... on ProductVariant { id title price { amount currencyCode } } } }`,
    { ids }
  );
  const nodes = (data?.data?.nodes || []).filter((n) => n && n.price && n.price.currencyCode === "USD");
  if (nodes.length !== ids.length) {
    console.error("[findVariantIDForMarket] US prices unavailable for", ids.length - nodes.length, "of", ids.length, "variants");
    return undefined;
  }
  usVariantPriceOptions = nodes.map((n) => ({ id: n.id, title: n.title, cents: Math.round(parseFloat(n.price.amount) * 100) }));
  return usVariantPriceOptions;
};

const findVariantIDForMarket = async (price, model, level) => {
  if (!window.Shopify || !Shopify.country || Shopify.country === "US") return findVariantID(price, model, level);
  try {
    const options = await loadUsVariantPriceOptions();
    if (!options) return undefined;
    const cents = Math.round(parseFloat(price) * 100);
    const atPrice = options.filter((v) => v.cents === cents);
    if (!atPrice.length) {
      console.error("[findVariantIDForMarket] no variant has US price", price, "in", Shopify.country);
      return undefined;
    }
    if (atPrice.length > 1 && model) {
      const wanted = buildTitleWords(`${level || ""} ${model}`);
      const matches = atPrice.filter((v) => buildTitleWords(v.title) === wanted);
      if (matches.length === 1) return matches[0].id;
    }
    // As the US price map does, keep the last variant at this price.
    const variantID = atPrice[atPrice.length - 1].id;
    console.log("[findVariantIDForMarket]", Shopify.country, "matched variant:", variantID);
    return variantID;
  } catch (error) {
    console.log("[findVariantIDForMarket] error", error);
    return undefined;
  }
};

const createListPropertiesDomElement = (attributes, lineItemDomElement) => {
    try {
      const properties = lineItemDomElement.querySelector(
        "#line_item_properties"
      );
      attributes.forEach((attribute) => {
        if (!attribute?.key) {
          return false;
        }
        let LiDomElement = document.createElement("LI");
        LiDomElement.innerHTML = attribute?.key + ": " + attribute?.value;
  
        if (attribute.key === "Lead Time") {
          LiDomElement.classList.add("lead_time-metafield_cart_line");
        }
        properties.appendChild(LiDomElement);
        //   console.log(attribute);
      });
      // console.log(lineItemDomElement);
      // console.log(properties);
      // console.log(attributes);
    } catch (error) {
      console.log(error);
    }
  };